import { LegendItem, Polygon, Raster, LayerGroupType } from "helpers/models";

const arr = ["Outside", "No Data", "Negligible", "No Observation"];

const transform = (legendItems: LegendItem[]): LayerGroupType => {
  const result: LayerGroupType = {};

  legendItems.forEach((item) => {
    const layerId = item.layerId;
    if (!result[layerId]) {
      result[layerId] = {};
    }

    item.rules.forEach((rule) => {
      const title = rule.title;
      const raster = (rule.symbolizers[0] as Raster)?.raster?.color;
      const polygon = (rule.symbolizers[0] as Polygon)?.polygon?.fill;

      const color = raster || polygon;
      if (layerId === "EQ_Landslide_Global_SwissRe") {
        result[layerId][title] = color;
        return;
      }
      if (layerId !== "WF_Wildfire_Global_SwissRe" && arr.includes(title)) {
        result[layerId][title] = "#CCCCCC";
        return;
      }
      if (color) {
        // && color === "#FFFFFF"
        result[layerId][title] = color;
        return;
      }
      result[layerId][title] = "#CCCCCC";
    });
  });

  return result;
};

export default transform;
